import { all, call } from 'redux-saga/effects';
import { encrypt, generateKeyPair, generateSecret, getKeyFromPem, getPrvKeyPem, getPubKeyPem, symmetricEncrypt } from 'helpers/crypto';
import ApiService from 'services/ApiService';
function* fetchSecurityKeys() {
    return yield call(ApiService.originalRequest, '/api/Security/Keys');
}
function* generateRecoveryAndBackupCodes(pcHash) {
    const recoveryCode = yield call(generateSecret);
    const { recoveryPublicKey, backupPublicKey } = yield call(fetchSecurityKeys);
    const recoveryPublicKeyObj = yield call(getKeyFromPem, recoveryPublicKey);
    const encryptedRecoveryCode = yield call(encrypt, recoveryCode, recoveryPublicKeyObj);
    const backupPublicKeyObj = yield call(getKeyFromPem, backupPublicKey);
    const encryptedBackupCode = yield call(encrypt, recoveryCode, backupPublicKeyObj);
    const encryptedRecoveryHash = yield call(symmetricEncrypt, pcHash, recoveryCode);
    return {
        encryptedBackupCode,
        encryptedRecoveryCode,
        encryptedRecoveryHash
    };
}
function* generateKeys(passphrase, pcHash, keyObjs = null) {
    const { prvKeyObj, pubKeyObj } = keyObjs || (yield call(generateKeyPair));
    const [prvKeyPem, pubKeyPem] = yield all([
        call(getPrvKeyPem, prvKeyObj, passphrase),
        call(getPubKeyPem, pubKeyObj)
    ]);
    const encryptedPassphrase = yield call(symmetricEncrypt, passphrase, pcHash);
    const { encryptedBackupCode, encryptedRecoveryCode, encryptedRecoveryHash } = yield call(generateRecoveryAndBackupCodes, pcHash);
    return {
        encryptedPrivateKey: prvKeyPem,
        publicKey: pubKeyPem,
        encryptedPassphrase,
        encryptedBackupCode,
        encryptedRecoveryCode,
        encryptedRecoveryHash
    };
}
export default {
    generateKeys,
    generateRecoveryAndBackupCodes
};
